import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/common/Layout';
import Button from '../components/common/Button';
import SEO from '../components/common/SEO';

const NotFoundPage: React.FC = () => {
  return (
    <Layout>
      <SEO 
        title="Page Not Found | Nemlingo"
        description="The page you're looking for doesn't exist. Return to Nemlingo's homepage to continue your language learning journey."
        keywords="page not found, 404, Nemlingo"
      />
      <div className="py-16 text-center">
        <h1 className="text-4xl font-bold text-gray-900 mb-4">404</h1>
        <h2 className="text-2xl font-medium text-gray-700 mb-8">Page Not Found</h2>
        <p className="text-gray-600 mb-8 max-w-md mx-auto">
          The page you're looking for doesn't exist or has been moved. 
          Let's get you back on track with your language learning journey.
        </p>
        <Link to="/">
          <Button size="lg">
            Return to Homepage
          </Button>
        </Link>
      </div>
    </Layout>
  );
};

export default NotFoundPage;
